module.exports = __webpack_public_path__ + "static/img/rotor_256.e5f1f5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rotor_256.png
// module id = c/V7
// module chunks = 0